import React from 'react';
import { SwitchCheckbox } from '@klarna/bubble-ui';

type Props = {
  label: string;
  value: boolean;
};

const SwitchCheckboxWrapper = ({ label, value, ...props }: Props): React.JSX.Element => {
  return (
    <SwitchCheckbox checked={value} {...props}>
      {label}
    </SwitchCheckbox>
  );
};

export default SwitchCheckboxWrapper;
